import { render } from "./IconInactive.vue?vue&type=template&id=3ed011d5"
import script from "./IconInactive.vue?vue&type=script&lang=js"
export * from "./IconInactive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__